<template>
  <div>
    <div class="apply-info">
      <div style="margin-left:10px;">
        <h3 style="font-size:14px;margin-bottom:5px;" v-cloak>
          <span v-if="applyData.ApplyType === 3">{{applyData.CreateName}}提交的代课申请</span>
          <span v-if="applyData.ApplyType === 1||applyData.ApplyType === 2">{{applyData.CreateName}}提交的调课申请</span>
        </h3>
        <div style="color:#606060">{{applyData.CreateByDateName}}</div>
        <div style="color:#E8A022" v-if="applyData.SubstituteStatus === 0">未审批</div>
        <div style="color:#E8A022" v-if="applyData.SubstituteStatus === 1">审批中</div>
        <div style="color:#21A83E" v-if="applyData.SubstituteStatus === 2">已通过</div>
        <div style="color:#D83737" v-if="applyData.SubstituteStatus === 3">已拒绝</div>
        <div style="color:#D83737" v-if="applyData.SubstituteStatus === 4">已撤销</div>
        <div style="color:#D83737" v-if="applyData.SubstituteStatus === 40">已撤回</div>
      </div>
    </div>
    <!-- 代课 -->
    <div v-if="applyData.ApplyType === 3">
      <div class="cell-item" v-for="(item,index) in applyInfo.Details" :key="index">
        <div class="detail-cell-item">
          <span>申请类型：</span>
          <span>代课申请</span>
        </div>
        <div class="detail-cell-item">
          <span>班级：</span>
          <span v-cloak>{{item.CoursePlanTableFullName}}</span>
        </div>
        <div class="detail-cell-item">
          <span>上课日期：</span>
          <span v-cloak>{{item.ClassDate?item.ClassDate.split('T')[0]:''}}({{item.DayName}})</span>
        </div>
        <div class="detail-cell-item">
          <span>上课节次：</span>
          <span v-cloak>{{item.TimeName}}{{item.SubjectName}}</span>
        </div>
        <div class="detail-cell-item">
          <span>代课教师：</span>
          <span v-cloak>{{item.SubstituteTeacherName}}</span>
        </div>
      </div>
      <div class="cell-item">
        <label class="item-left">代课原因</label>
        <div class="item-right" v-cloak>{{applyInfo.Description}}</div>
      </div>
    </div>
    <!-- 调课 -->
    <div v-if="applyData.ApplyType === 1||applyData.ApplyType === 2">
      <div class="cell-item" v-for="(item,index) in applyInfo.Data" :key="index">
        <div class="detail-cell-item">
          <span>申请类型：</span>
          <span>调课申请</span>
        </div>
        <div class="detail-cell-item">
          <span>班级：</span>
          <span v-cloak>{{item.StudentOrganizationFullName}}</span>
        </div>
        <div class="detail-cell-item">
          <span>原上课日期：</span>
          <span v-cloak>{{item.SourceClassDate?item.SourceClassDate.split('T')[0]:''}}({{item.SourceWeekName}})</span>
        </div>
        <div class="detail-cell-item">
          <span>原上课节次：</span>
          <span v-cloak>{{item.SourceInfo}}{{item.SourceSubjectName}}</span>
        </div>
        <div class="detail-cell-item">
          <span>新上课日期：</span>
          <span v-cloak>{{item.TargetClassDate?item.TargetClassDate.split('T')[0]:''}}({{item.TargetWeekName}})</span>
        </div>
        <div class="detail-cell-item">
          <span>新上课节次：</span>
          <span v-cloak>{{item.TargetInfo}}</span>
        </div>
      </div>
      <div class="cell-item">
        <label class="item-left">调课原因:</label>
        <div class="item-right" v-cloak>{{applyInfo.Description}}</div>
      </div>
    </div>

    <!-- 审批流程 -->
    <div class="approval-box">
      <p class="flow-title">审批流程</p>
      <div class="detail-flow" v-if="approvalData!==''">
        <div class="detail-flow-box">
          <div class="detail-portrait" v-cloak v-if='approvalData.ApprovalFlow.OriginatorName'>
            {{approvalData.ApprovalFlow.OriginatorName.substring((approvalData.ApprovalFlow.OriginatorName.length-2),approvalData.ApprovalFlow.OriginatorName.length)}}
          </div>
          <div v-else>
             --
          </div>
          <div style="margin-left:20px;">
            <div style="color:#161616;font-weight:400;font-size:14px;">发起申请</div>
            <div class="detail-user-name" v-cloak>
              {{approvalData.ApprovalFlow.OriginatorName}}
            </div>
          </div>
          <div class="detail-date" v-cloak>
            {{ approvalData.ApprovalFlow.CreateByDate?approvalData.ApprovalFlow.CreateByDate.split('T')[0]:'' }}
          </div>
        </div>
      </div>
      <div class="detail-flow" v-for="(item,index) in approvalData.ApprovalFlow.Nodes" :key="index">
        <!--审批节点 只有一个人 -->
        <div class="detail-flow-box" v-if="item.ApprovalFlowNodeApprovalMembers.length===1">
          <div class="detail-portrait">
            {{item.ApprovalFlowNodeApprovalMembers[0].FullName.substring((item.ApprovalFlowNodeApprovalMembers[0].FullName.length-2),item.ApprovalFlowNodeApprovalMembers[0].FullName.length)}}
          </div>
          <div style="margin-left:20px;">
            <div class="detail-user-name">
              {{item.ApprovalFlowNodeApprovalMembers[0].FullName}}
              ({{statusData[item.ApprovalFlowNodeApprovalMembers[0].Status]}})
            </div>
            <div class="detail-user-name">{{item.ApprovalFlowNodeApprovalMembers[0].Opinion}}</div>
          </div>
          <div class="detail-date" v-if="item.IsComplete">
            {{item.CompleteTime?item.CompleteTime.split('T')[0]:'' }}
          </div>
        </div>
        <!--审批节点 多人审批 -->
        <div class="detail-flow-box" v-if="item.ApprovalFlowNodeApprovalMembers.length>1">
          <div class="detail-portrait">审批</div>
          <div style="margin-left:20px;">
            <div class="detail-user-name">审批人{{item.ApprovalFlowNodeApprovalMembers.length}}人</div>
            <div class="cc-user-li">
              <div v-for="(ap,aIndex) in item.ApprovalFlowNodeApprovalMembers" :key="aIndex" style="margin-right:10px;">
                <div v-if="aIndex<2">
                  <div class="detail-cc-portrait">{{ap.FullName.substring((ap.FullName.length-2),ap.FullName.length)}}</div>
                  <div class="detail-user-name nowrap">{{ap.FullName}}</div>
                </div>
              </div>
              <div v-if="item.ApprovalFlowNodeApprovalMembers.length>2">
                <div class="detail-cc-portrait" @click="showMore=true">更多</div>
                <div class="detail-user-name nowrap">更多</div>
              </div>
              <!-- 更多 -->
              <van-popup v-model="showMore" position="bottom" :style="{height: '50%'}">
                <div class="more-list">
                  <div v-for="(moreAp,mIndex) in item.ApprovalFlowNodeApprovalMembers" :key="mIndex" style="margin-right:10px;">
                    <div v-if="mIndex>1">
                      <div class="detail-cc-portrait">{{moreAp.FullName.substring((moreAp.FullName.length-2),moreAp.FullName.length)}}</div>
                      <div class="detail-user-name">{{moreAp.FullName}}</div>
                    </div>
                  </div>
                </div>
              </van-popup>
            </div>
          </div>
          <div class="detail-date" v-if="item.IsComplete">
            {{item.CompleteTime?item.CompleteTime.split('T')[0]:'' }}
          </div>
        </div>
        <!-- 抄送 -->
        <div class="detail-flow-box" v-if="item.ApprovalFlowNodeCCMembers.length>0">
          <div class="detail-portrait">
            抄送
          </div>
          <div style="margin-left:20px;">
            <div class="detail-user-name">抄送给{{item.ApprovalFlowNodeCCMembers.length}}人</div>
            <div class="cc-user-li">
              <div v-for="(cc,cIndex) in item.ApprovalFlowNodeCCMembers" style="margin-right:10px;" :key="cIndex">
                <div class="detail-cc-portrait">{{cc.FullName.substring((cc.FullName.length-2),cc.FullName.length)}}</div>
                <div class="detail-user-name">{{cc.FullName}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fotter-fix" v-if="applyData.SubstituteStatus === 2">
      <div class="approval-btn undo-btn" @click="undo" v-if="approvalData.IsOriginator">撤销</div>
    </div>
  </div>
</template>

<script>
import xyapi from "@/common/api";
export default {
  components: {},
  data () {
    return {
      applyData: {
        ApplyType: '',
      },
      applyInfo: {
        Description: '',
        Data: [],
        ApproverDate: '',
        ApproverName: '',
        CreateByDate: '',
        CreateName: '',
        Explain: [],
        SubstituteStatusName: '',
        SubstituteStatus: '',
        info: '',
        type: '',
        DetailParameter: '',
      },
      statusData: ['未审批', '审批中', '已通过', '已拒绝', '已撤销', '已过期'],
      //审批
      opinions: '',
      approvalData: '',
      showMore: false,
    };
  },
  created: function () {
    this.applyData = this.$store.state.csmstimetable.applyObj;
    //  if (xy.param.getValues("applyData") !== undefined) {
    //       this.applyData = xy.param.getValues("applyData");
    //   }
    if (this.applyData.ApplyType === 1 || this.applyData.ApplyType === 2) {
      this.getAdjustInfo();
    } else if (this.applyData.ApplyType === 3) {
      this.getSubstituteInfo();
    }
    this.getApprovalFlow();
  },
  mounted: function () {

  },
  methods: {
    //代课
    async getSubstituteInfo () {
      this.xy.loading();
      let res = await xyapi.get(`${this.$store.state.apiPath}/api/ClassTableGenerateForTeacherSubstituteApply/GetSubstituteInfo`,
        {
          classTableGenerateForTeacherSubstituteApplyID: this.applyData.ID,
        }
      );
      this.xy.unloading();
      if (res.success) {
        this.applyInfo = res.data;
      }
    },
    //调课
    async getAdjustInfo () {
      this.xy.loading();
      let res = await xyapi.get(`${this.$store.state.apiPath}/api/ClasstableGenerateForTeacherAdjustmentApply/GetTeaherApplyInfo`,
        {
          appilyID: this.applyData.ID
        }
      );
      this.xy.unloading();
      if (res.success) {
        this.applyInfo = res.data;
      }
    },
    //审批流
    async getApprovalFlow () {
      this.xy.loading();
      let res = await xyapi.get(`${this.$store.state.apiPublic}/api/ApprovalProcess/GetApprovalFlow`,
        {
          approvalFlowID: this.applyData.ApprovalFlowID
        }
      );
      this.xy.unloading();
      if (res.success) {
        this.approvalData = res.data;
      }
    },
    //撤销
    async undo () {
      if (this.applyData.ApplyType === 3) {//代课
        this.xy.loading();
        let res = await xyapi.post(`${this.xyMApi}/csms/api/ClassTableGenerateForTeacherApplyExamine/RevokeTeacherSubstituteApply`,
          {
            id: this.applyData.ID,
          });
        this.xy.unloading();
        if (res.success) {
          this.xy.msgSuc('撤销成功');
          this.back();
        } else {
          this.undoMsg = res.data.data;
          this.undoModal = true;
        }
      } else if (this.applyData.ApplyType === 1) {//单周
        this.xy.loading();
        let res = await xyapi.post(`${this.xyMApi}/csms/api/ClassTableGenerateForTeacherApplyExamine/RevokeTeacherAdjustmentApply`,
          {
            id: this.applyData.ID,
          }
        );
        this.xy.unloading();
        if (res.success) {
          this.xy.msgSuc('撤销成功');
          this.back();
        }
      }
    },
    //关闭
    back () {
      this.$router.push({ path: "/home/recordTable" });
    }
  }
};
</script>
<style lang='less' >
 .van-notify{
  line-height: 1;
}
.apply-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #fff;
  margin-bottom: 10px;
  padding: 10px;
}
.head-portrait {
  width: 50px;
}
.status-img {
  flex: 1;
  text-align: right;
}
.cell-item {
  background: #fff;
  padding: 14px 10px 14px 20px;
  color: #333333;
  margin-bottom: 10px;
  font-size: 28px;
}
.detail-cell-item {
  color: #666666;
  padding: 10px 0;
  font-size: 28px;
}

.item-left {
  width: 120px;
  display: inline-block;
  vertical-align: top;
}

.item-right {
  display: inline-block;
  color: #666666;
  width: calc(100% - 150px);
}

.h-title {
  font-size: 18px;
  margin-bottom: 16px;
}

.time-item {
  font-size: 16px;
  color: #666666;
  margin-bottom: 16px;
}

.round1 {
  width: 12px;
  height: 12px;
  background: rgba(226, 226, 227, 1);
  border: 2px solid rgba(226, 226, 227, 1);
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  vertical-align: middle;
}

.round2 {
  width: 13px;
  height: 13px;
  background: rgba(255, 255, 255, 1);
  border: 2px solid rgba(226, 226, 227, 1);
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  vertical-align: middle;
}

.subject-teacher {
  background: rgba(246, 246, 247, 1);
  border-radius: 14px 0px 14px 0px;
  padding: 4px 10px;
  display: inline-block;
  font-size: 16px;
  color: #666666;
}

.divider-line {
  height: 1px;
  background: #eeeeee;
  margin: 15px 0;
}

.fotter-fix {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99;
  height: 120px;
  background: #fff;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 60px;
}
.approval-btn {
  flex: 1;
  margin: 0 15px;
  height: 80px;
  line-height: 80px;
  border-radius: 44px;
  text-align: center;
}
.cancle-btn {
  border: 1px solid #4196ff;
  color: #2980fe;
}

.submit-btn {
  background: #2980fe;
  color: #ffffff;
}
.undo-btn {
  height: 80px;
  line-height: 80px;
  background: rgba(41, 128, 254, 1);
  border-radius: 44px;
  text-align: center;
  background: #2980fe;
  color: #ffffff;
}
.teacher-li {
  text-align: center;
  font-size: 18px;
  padding: 5px 0;
}

.approval-box {
  padding: 30px 30px;
  background: #fff;
  font-size: 28px;
  margin-bottom: 120px;
  padding-bottom: 120px;
  margin-top: 20px;
  .flow-title {
    font-size: 28px;
    color: #666666;
    margin-bottom: 40px;
    margin-bottom: 10px;
  }
  .font-aplay {
    color: #161616;
    font-weight: 400;
    font-size: 24px;
    margin-bottom: 10px;
  }
}
.approval-box .approval-textarea {
  width: 100%;
  height: 114px;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #dbdbdb;
}

.approval-box .approval-textarea textarea {
  width: 100%;
  height: 100%;
  color: #161616;
  border: none;
}

.detail-flow {
  padding-left: 20px;
}
.detail-flow-box {
  position: relative;
  border-left: 2px solid #c6c6c6;
  display: flex;
  min-height: 140px;
}
.detail-flow:last-child .detail-flow-box:last-child {
  border-left: none;
}
.detail-flow-box .detail-portrait {
  width: 66px;
  height: 66px;
  line-height: 66px;
  background: rgba(41, 128, 254, 1);
  border: 2px solid #fff;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  position: absolute;
  left: -33px;
  top: 0;
  z-index: 1;
}
.detail-flow-box .detail-user-name {
  color: #959595;
  font-weight: 400;
  font-size: 24px;
  margin-bottom: 10px;
}
.detail-flow-box .detail-date {
  font-size: 16px;
  color: #959595;
  font-weight: 400;
  flex: 1;
  text-align: right;
}
.detail-flow-box .cc-user-li {
  margin-top: 8px;
  display: flex;
  align-items: center;
}
.detail-flow-box .detail-cc-portrait {
  width: 50px;
  height: 50px;
  line-height: 50px;
  background: rgba(41, 128, 254, 1);
  border-radius: 50%;
  text-align: center;
  color: #fff;
  margin: auto;
}
.more-list {
    background: #fff;
    padding: 10px;
    border-radius: 8px;
    min-height: 50px;
    display: flex;
    justify-content: flex-start;
  }
</style>  

